module.exports = __webpack_public_path__ + "media/application/images/svgs/layers-30c7559f6624728a01cf80f310071d91.svg";